import { Injectable } from '@angular/core';
import { AnalyticsEventProvider } from './analytics-event-provider.service';
import { UploadEvent } from '../events/upload-event';

export interface UploadEventArgs {
  upload_text?: string;
  field_name?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsUploadEventProvider extends AnalyticsEventProvider<UploadEvent> {
  createAndPush(args: UploadEventArgs): void {
    this.push(
      new UploadEvent({
        upload_text: args.upload_text,
        field_name: args.field_name,
      }),
    );
  }
}
